import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('composer-ui', {
  library: 'composer-ui'
});